import React from 'react';
import { Linking } from 'react-native';
import StubScreen from './_StubScreen';

export default function InvestScreen() {
  return (
    <StubScreen
      title="For Investors"
      sourcePath="garageiq-web/app/invest/page.js"
      summary="Investor-facing pitch deck: problem, solution, partnerships (Haynes, Chilton, AutoZone), revenue model, team, and roadmap."
      todo={[
        'This is mostly static content — port is mechanical (each <section> → <View>).',
        'The page is long; consider splitting into a Screen + InvestSections.jsx file for readability.',
        'Email CTAs (mailto:investors@…) need Linking.openURL on RN.',
        'No localStorage / browser APIs in this page — should be a clean port.',
      ]}
      ctaLabel="Email investors@mygarageiq.com"
      onCta={() => Linking.openURL('mailto:investors@mygarageiq.com')}
    />
  );
}
